import { render, staticRenderFns } from "./WaterfallSlot.vue?vue&type=template&id=c878e040&"
import script from "./WaterfallSlot.vue?vue&type=script&lang=js&"
export * from "./WaterfallSlot.vue?vue&type=script&lang=js&"
import style0 from "./WaterfallSlot.vue?vue&type=style&index=0&id=c878e040&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports